<template>
    <v-container grid-list-lg fluid>
      <v-layout row wrap>
        <v-flex xs12>
          <v-subheader>
            (Se adjunta al final de todos los emails enviados.)
          </v-subheader>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12>
          <vue-editor
            v-model="form.text"
            useCustomImageHandler
            @imageAdded="handleImageAdded"
            :editorToolbar="editorToolbarSigned"></vue-editor>
        </v-flex>
      </v-layout>
      <v-card-actions>
        <v-layout row wrap justify-end>
          <v-flex shrink>
            <v-btn class="k-orange-linear-text" flat @click="saveSignature">
              GUARDAR
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-container>
</template>
<script>
import { VueEditor } from 'vue2-editor';
import emailEditorToolbarMixin from '@/mixins/emailEditorToolbar';

export default {
  mixins: [
    emailEditorToolbarMixin,
  ],
  components: {
    VueEditor,
  },
  props: {
    user: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: {
        text: '',
      },
    };
  },
  computed: {
    editorToolbarSigned() {
      return this.editorToolbar.concat([['code-block']]);
    },
  },
  methods: {
    saveSignature() {
      this.axios.post('chat/center/signature', {
        signature: this.form.text,
      }).then(({ data }) => {
        if (typeof data === 'string') {
          this.user.email_signature = data;
        } else {
          this.user.email_signature = '';
        }
        this.$emit('update:model', true);
        this.$emit('update:msg', 'Firma guardada satisfactoriamente.');
        this.$emit('saved');
      });
    },
  },
  watch: {
    'user.email_signature': {
      immediate: true,
      handler(value) {
        this.form.text = value;
      },
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/chat_center_v2/config/Signature.vue